// Move to single source
export default [
  {
    value: "all",
  },
  {
    value: "abbvie",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "amgen",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy or if the covered entity agrees to provide 340B claims data for its in-house pharmacies",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "astellas",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      exemptions:
        "Grantees and contract pharmacies located in Louisiana and Arkansas for covered entities located in Louisiana and Arkansas respectively are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "astrazeneca",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
    },
  },
  {
    value: "bausch_n_lomb",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "bayer",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies for non-LDN products must be within 40 miles of the covered entity parent site",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "biogen",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies for hospital entity types",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "boehringer_ingelheim",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies for non-LDN products must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "bristol_myers_squibb",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
    },
  },
  {
    value: "cytokinetics",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
    },
  },
  {
    value: "eisai",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      exemptions:
        "Grantees as well as all covered entities located in Louisiana and Arkansas are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "eli_lilly",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
    },
  },
  {
    value: "emd_serono",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
    },
  },
  {
    value: "exelixis",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies other than designated contract pharmacies",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "genentech",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies permitted as part of a state-level exemption",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "glaxosmithkline",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      whollyOwned:
        "Contract pharmacies that are owned by or share common ownership with the 340B covered entity are exempted from the policy",
    },
  },
  {
    value: "incyte",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "jazz",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "johnson_n_johnson",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy or if the covered entity agrees to provide 340B claims data for its in-house pharmacies",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "leo",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
    },
  },
  {
    value: "liquidia",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy or if the covered entity agrees to provide 340B claims data for its in-house pharmacies",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
    },
  },
  {
    value: "merck",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies permitted as part of a state-level exemption",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      exemptions:
        "Non-CH grantees as well as all covered entities located in Louisiana and Arkansas are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "mtpa",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies permitted as part of a state-level exemption",
    },
  },
  {
    value: "novo_nordisk",
    policies: {
      cpDesignations:
        "Covered entity may designate a single retail and a single specialty contract pharmacy",
      claimsCollection:
        "340B claims are required for all wholly-owned contract pharmacies that are permitted outside of a contract pharmacy designation",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
      whollyOwned:
        "Contract pharmacies that are owned by or share common ownership with the 340B covered entity are permitted with claims submissions",
    },
  },
  {
    value: "novartis",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "pfizer",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies for DON products and VYNDA",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
      whollyOwned:
        "Contract pharmacies that are owned by or share common ownership with the 340B covered entity are permitted; claims submissions are required for DON products and VYNDA",
    },
  },
  {
    value: "sandoz",
    policies: {
      cpDesignations: "Covered entity may designate a single contract pharmacy location",
      claimsCollection: "340B claims are required for all designated contract pharmacies",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "sanofi",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "Entity-owned and Contract Pharmacies are required to submit claims-level data elements for hospital types, except for CH entity types, for all 340B utilization for covered outpatient drugs",
    },
  },
  {
    value: "sobi",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
    },
  },
  {
    value: "stemline",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all contract pharmacies permitted as part of a state-level exemption",
    },
  },
  {
    value: "sumitomo",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      claimsCollection:
        "340B claims are required for all contract pharmacies permitted as part of a state-level exemption",
      whollyOwned:
        "Contract pharmacies that are owned by or share common ownership with the 340B covered entity are exempted from the policy",
    },
  },
  {
    value: "takeda",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all wholly-owned and designated contract pharmacies",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "teva",
    policies: {
      lookback:
        "340B claims must be submitted within 45 days of the date of dispense to be considered a valid claim submission",
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      claimsCollection:
        "340B claims are required for all designated contract pharmacies or contract pharmacies permitted as part of a state-level exemption",
      geofence:
        "Designated contract pharmacies must be within 40 miles of the covered entity parent site",
      exemptions:
        "Grantees as well as all covered entities located in Louisiana and contract pharmacies in Arkansas for covered entities in Arkansas are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "ucb",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
    },
  },
  {
    value: "vertex",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      exemptions: "Grantees are exempted from the contract pharmacy policy",
    },
  },
  {
    value: "viatris",
    policies: {
      cpDesignations:
        "Covered entity may designate a single contract pharmacy location if the covered entity does not operate an in-house pharmacy",
      exemptions: "Non-CH grantees are exempted from the contract pharmacy policy",
    },
  },
];
